@if (hasAccess && !openNewWindow) {
    <a (click)="onClick()" [routerLink]="url" tabindex="-1">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </a>
}
@if (hasAccess && openNewWindow) {
    <a (click)="onClick()" [routerLink]="url" tabindex="-1" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </a>
}
@if (!hasAccess) {
    <span>
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </span>
}
<ng-template #contentTpl><ng-content></ng-content></ng-template>
